<ngx-loading-bar color="#15b39b" height="3px" [fixed]="false" [includeSpinner]="false"
  [value]="(loader.progress$|async) || 0"></ngx-loading-bar>
<ngx-spinner [fullScreen]="false" type="ball-clip-rotate-multiple" bdColor="rgba(51,51,51,0.8)" size="medium"
  color="#fff">
</ngx-spinner>
<form [formGroup]="ClientFormGroup" #createclientform="ngForm" (ngSubmit)="createClient()" novalidate>
  <div class="divclientinfo" flex="col" fxFlex.gt-sm="100" fxFlex="100">
    <div fxLayout="column" fxLayoutAlign="center stretch" class="clientbasciinfo">
      <Teranet-ClientTitle [ClientTitle]="'Client Files Information'" [IconName]="'university'"></Teranet-ClientTitle>
      <div *ngIf="isShow" style="padding:30px">
 <!--       <div class="title">
          <h5>Client Info5</h5>
        </div>

        <div>
          <mat-form-field class="col-md-4" appearance="outline">
            <mat-label>Client Id</mat-label>
            <input matInput placeholder="Client Id" type="number" autocomplete="off" data-lpignore="true"
              formControlName="id" required>
            <mat-error *ngIf="ClientFormGroup.get('id').hasError('required')">
              Please enter client id
            </mat-error>
            <mat-error *ngIf="ClientFormGroup.get('id').hasError('invalidNumber')">
              Invalid Number
            </mat-error>
            <mat-error *ngIf="isIdexisting()">
              Client id already exists
            </mat-error>
          </mat-form-field>
          <mat-form-field class="col-md-4" appearance="outline">
            <mat-label>Corporation Code</mat-label>
            <input matInput placeholder="Corporation Code" id="corporationcode" data-lpignore="true"
              Name="txtcorporationcode" autocomplete="off" type="text" formControlName="corporationcode" required>
            <mat-error *ngIf="ClientFormGroup.get('corporationcode').hasError('required')">Please enter corporation code
            </mat-error>
          </mat-form-field>
          <mat-form-field class="col-md-4" appearance="outline">
            <mat-label>Corporation Name</mat-label>
            <input matInput placeholder="Corporation Name" type="text" data-lpignore="true"
              formControlName="corporationname" required>
            <mat-error *ngIf="ClientFormGroup.get('corporationname').hasError('required')">Please enter corporation name
            </mat-error>
          </mat-form-field>
          <mat-form-field class="col-md-4" appearance="outline">
            <mat-label>SPAES Client App Id</mat-label>
            <input matInput placeholder="SPAES Client App Id" type="number" min="0" data-lpignore="true"
              formControlName="spacesclientappid" [required]="isSpaesClientAppIdRequired">
            <mat-error *ngIf="ClientFormGroup.get('spacesclientappid').hasError('required')">Please enter SPAES Client
              App Id
            </mat-error>
            <mat-error *ngIf="ClientFormGroup.get('spacesclientappid').hasError('min')">
              Please enter a number greater than -1
            </mat-error>
          </mat-form-field>
          <mat-form-field class="col-md-4" appearance="outline">
            <mat-label>Web API User Name</mat-label>
            <input matInput placeholder="Web API User Name" type="text" data-lpignore="true"
              formControlName="webapiusername" required>
            <mat-error *ngIf="ClientFormGroup.get('webapiusername').hasError('required')">Please enter corporation code
            </mat-error>
          </mat-form-field>
          <mat-form-field class="col-md-4" appearance="outline">
            <mat-label>CSRS User Name</mat-label>
            <input matInput placeholder="CSRS User Name" type="text" data-lpignore="true"
              formControlName="csrsusername">
            <mat-error *ngIf="ClientFormGroup.get('csrsusername').hasError('required')">Please enter csrs user name
            </mat-error>
          </mat-form-field>
          <mat-form-field class="col-md-4" appearance="outline">
            <mat-label>Last Batch Number</mat-label>
            <input matInput placeholder="Last Batch Number" type="number" min="0" data-lpignore="true"
              formControlName="lastfilenumber">
            <mat-error *ngIf="ClientFormGroup.get('lastfilenumber').hasError('min')">
              Please enter a number greater than -1
            </mat-error>
          </mat-form-field>

          <mat-checkbox class="col-md-4" formControlName="isactive">Enable Client</mat-checkbox>
          <mat-checkbox class="col-md-4" formControlName="fileclient" (change)="onsftpChange($event)">File Client
          </mat-checkbox>
          <mat-checkbox class="col-md-4" formControlName="apiclient" (change)="onapiChange($event)">API Client
          </mat-checkbox>
        </div>
    -->
        <div class="title">
          <h5 class="col-md-8">Client File Info</h5>
          <div class="addbtn">
            <button mat-button type="button" (click)="addClientFileInfo()" *ngIf="!this.Readonly">
              <div class="btnicon">
                <fa-icon icon="plus" id="plus" class="fa-lg" matTooltipPosition="above"></fa-icon>
              </div>
              <div class="btntext">Add File Info</div>
            </button>
          </div>
        </div>
        <div class="row">
          <div class="filearray" formArrayName="clientfileinfomodel">
            <div *ngFor="let clientfileinfo of clientfileinfos.controls; let i = index;">
              <mat-accordion>
                <mat-expansion-panel [expanded]="(FileInfo_step===i)" (opened)="setFileInfoStep(i)">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <fa-icon icon="file-alt" id="file-alt" class="fa-lg" matTooltipPosition="above"></fa-icon>
                      {{i+1}}
                    </mat-panel-title>
                    <mat-panel-description>
                      <div *ngIf="clientfileinfos">{{ clientfileinfo.get('description').value}}</div>
                    </mat-panel-description>
                  </mat-expansion-panel-header>
                  <div [formGroupName]="i" [ngClass]="{'disableDiv': true}">
                    <mat-form-field class="col-md-4" appearance="outline">
                      <mat-label>File Type</mat-label>
                      <mat-select formControlName="filetypeid" >
                        <mat-option *ngFor="let filetype of filetypes" [value]="filetype.id">{{filetype.description}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-form-field class="col-md-4" appearance="outline">
                      <mat-label>File Name</mat-label>
                      <input matInput placeholder="File Name" type="text" data-lpignore="true"
                        formControlName="filename">
                    </mat-form-field>
                    <mat-form-field class="col-md-4" appearance="outline">
                      <mat-label>File Extension</mat-label>
                      <input matInput placeholder="File Extension" type="text" data-lpignore="true"
                        formControlName="fileextension">
                    </mat-form-field>
                    <mat-form-field class="col-md-4" appearance="outline">
                      <mat-label>SFTP Source Folder</mat-label>
                      <input matInput placeholder="SFTP Source Folder" type="text" data-lpignore="true"
                        formControlName="sftpsourcefolder">
                      <mat-error *ngIf="clientfileinfos.controls[i].get('sftpsourcefolder').hasError('required')">Please
                        enter SFTP source folder</mat-error>
                    </mat-form-field>
                    <mat-form-field class="col-md-4" appearance="outline">
                      <mat-label>{{gettxt_SFTPFolder(i)}}</mat-label>
                      <input matInput placeholder={{gettxt_SFTPFolder(i)}} type="text" data-lpignore="true"
                        formControlName="sftpdestinationfolder">
                    </mat-form-field>
                    <mat-form-field class="col-md-4" appearance="outline">
                      <mat-label>Minutes Between Checks</mat-label>
                      <input matInput placeholder="Minutes Between Checks" type="number" data-lpignore="true"
                        formControlName="minutesbetweenchecks" >                      
                    </mat-form-field>
                    <mat-form-field class="col-md-4" appearance="outline">
                      <mat-label>Minutes to Wait</mat-label>
                      <input matInput placeholder="Minutes to Wait" type="number" data-lpignore="true"
                        formControlName="minutestowait" >                     
                    </mat-form-field>
                    <mat-form-field class="col-md-4" appearance="outline">
                      <mat-label>SFTP Info</mat-label>
                      <mat-select formControlName="sftpinfoid" >
                        <mat-option *ngFor="let sftpinfo of ALLSFTP_Select[i].SFTPInfos" [value]="sftpinfo.id">
                          {{sftpinfo.username}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-form-field class="col-md-4" appearance="outline">
                      <mat-label>File Name Expression</mat-label>
                      <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="4" cdkAutosizeMaxRows="4"
                        placeholder="File Name Expression" formControlName="filenameexpression"></textarea>                      
                    </mat-form-field>
                    <mat-form-field class="col-md-8" appearance="outline">
                      <mat-label>File Description</mat-label>
                      <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="4" cdkAutosizeMaxRows="4"
                        placeholder="Description" formControlName="description"></textarea>                     
                    </mat-form-field>
                    <mat-form-field class="col-md-4" appearance="outline" *ngIf="clientfileinfos.controls[i].get('filetypeid').value===10">
                      <mat-label>Parent File</mat-label>
                      <mat-select formControlName="clientfileid" >
                        <mat-option *ngFor="let clientfile of clientfiles" [value]="clientfile[0]">{{clientfile[1]}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <div *ngIf="clientfileinfos.controls[i].get('filetypeid').value===1">
                      <mat-form-field class="col-md-4" appearance="outline">
                        <mat-label>Rejected Alert Threshold</mat-label>
                        <input matInput placeholder="Rejected Alert Threshold" type="number" 
                          data-lpignore="true" formControlName="rejectedalertthreshold">                        
                      </mat-form-field>
                      <mat-label *ngIf="clientfileinfos.controls[i].get('rejectedalertinpercent').value">%</mat-label>
                      <mat-checkbox class="col-md-4" formControlName="rejectedalertinpercent">Use Percentage
                      </mat-checkbox>
                    </div>
                    <div>
                      <mat-checkbox class="col-md-4" [disabled]="Readonly">
                        All SFTP Details</mat-checkbox>
                      <mat-checkbox class="col-md-4" formControlName="disableduplicatefilenamecheck">
                        Disable Duplicate Filename Check
                      </mat-checkbox>
                      <mat-checkbox class="col-md-4" formControlName="bypassemptyreturnfile" >
                        Skip Empty Return File Generation
                      </mat-checkbox>
                      <mat-checkbox class="col-md-4" formControlName="isactive">Enable</mat-checkbox>
                    </div>
                  </div>
                  <div class="deletebtn" *ngIf="i>-1">
                    <button mat-button type="button" (click)="removeClientFileInfo(i)" *ngIf="!this.Readonly">
                      <div class="btnicon">
                        <fa-icon icon="minus" id="minus" class="fa-lg" matTooltipPosition="above"></fa-icon>
                      </div>
                      <div class="btntext">Delete File Info</div>
                    </button>
                    <button mat-button type="button" (click)="edit(clientfileinfo)" *ngIf="!this.Readonly">                      
                      <div class="btntext">Edit</div>
                    </button>
                  </div>
                </mat-expansion-panel>
              </mat-accordion>
            </div>
          </div>
        </div>

        <div class="savebtn">
          <button mat-button type="submit" *ngIf="!this.Readonly">
            <div class="btnicon">
              <fa-icon icon="save" id="plus" class="fa-lg" matTooltipPosition="above"></fa-icon>
            </div>
            <div class="btntext" matStepperNext>Save</div>
          </button>
        </div>
      </div>

    </div>
  </div>
</form>